import CodeSplitEnvWrapper from '../../../components/common/env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentsProcessorsSectionWrapper = () => {
  return /*#__PURE__*/_jsx("div", {
    id: "payments-section",
    children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
      authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */'./InAppPaymentsProcessorsSection'),
      publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */'./PublicPaymentsProcessorsSection')
    })
  });
};
export default PaymentsProcessorsSectionWrapper;